import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_3 = { class: "mg-l-20" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 当前模板文件： ")
const _hoisted_5 = { class: "vo-ft-pry" }

import { ref, reactive, unref, onMounted, defineComponent } from 'vue';
import { FormRules, ElForm } from 'element-plus';
import { UploadFile } from '@/components/plugins/uploads/Index';
import { CtTempBase } from '../../../../apis/ct_templates/templates.dto';
import { useCtCategory } from '@/store/category.store';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  emits: ['register'],
  setup(__props, { expose, emit: $emits }) {

defineComponent({ UploadFile });


const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	loading: false,
	categoryList: [] as any[],
	rules: {
		category_id: [{ required: true, message: '请选择合同类别', trigger: 'change' }],
		template_type: [{ required: true, message: '请选择模板类型', trigger: 'change' }],
		enabled_day: [{ required: true, message: '生效日期不能留空', trigger: 'change' }],
		invalid_day: [{ required: true, message: '失效日期不能留空', trigger: 'change' }],
		code: [{ required: true, message: '模板编号不能留空', trigger: 'change' }],
		name: [{ required: true, message: '模板名称不能留空', trigger: 'change' }],
	} as FormRules,
});

const typeSelectList = ref<SelectItem[]>([
	{ name: '文档模板', value: 'f62124f4-1a54-583c-d870-d07fd400d78b' },
	{ name: '签署模板', value: '1f2d36f9-b2e9-9b93-a86b-c454ea442934' },
]);

const formSchema = ref<CtTempBase>({
	category_id: '',
	code: '',
	name: '',
	template_type: '',
	is_enabled: 'Y',
	enabled_day: moment().format('YYYY-MM-DD'),
	invalid_day: '',
	version: 1,
	remark: '',
});

/* 外部调用的属性或方法 */
const funcs = {
	getLoadStatus: (): boolean => {
		return state.loading;
	},
	/* 设置读取状态 */
	setLoadStatus: (isLoad: boolean) => {
		state.loading = isLoad;
	},
	/* 获取表单数据 */
	getFormData: () => {
		return unref(formSchema);
	},
	/* 设置表单数据 */
	setFormData: (data: any): void => {
		formSchema.value = Object.assign(unref(formSchema), data);
	},
};

/* 文件返回回调数据 */
const onUploadSuccess = (file: any) => {
	const fileData = {
		material: { id: file.id, file_name: file.file_name },
	};
	formSchema.value = Object.assign(unref(formSchema), fileData);
};

expose({ funcs });

onMounted(() => {
	state.categoryList = useCtCategory().getTreeList();
	$emits('register', unref(elFormRef)?.$parent, unref(elFormRef));
});

return (_ctx: any,_cache: any) => {
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
    ref_key: "elFormRef",
    ref: elFormRef,
    size: "small",
    model: formSchema.value,
    "label-width": "100px",
    "label-position": 'right',
    rules: _unref(state).rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "合同分类",
        prop: "category_id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tree_select, {
            style: {"width":"100%"},
            modelValue: formSchema.value.category_id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.category_id) = $event)),
            data: _unref(state).categoryList,
            accordion: "",
            filterable: "",
            clearable: "",
            placeholder: "请选择合同分类",
            "default-expanded-keys": [formSchema.value.category_id]
          }, null, 8, ["modelValue", "data", "default-expanded-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "模板编号",
        prop: "code"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formSchema.value.code,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.code) = $event)),
            type: "text",
            placeholder: "请输入模板编号"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "模板名称",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formSchema.value.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.name) = $event)),
            type: "text",
            placeholder: "请输入模板名称"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "模板类别",
        prop: "template_type"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: formSchema.value.template_type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.template_type) = $event)),
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeSelectList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.name,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "生效日期",
        prop: "enabled_day"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            style: {"width":"100%"},
            modelValue: formSchema.value.enabled_day,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.enabled_day) = $event)),
            type: "date",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            placeholder: "模板生效日期"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "失效日期",
        prop: "invalid_day"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            style: {"width":"100%"},
            modelValue: formSchema.value.invalid_day,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.invalid_day) = $event)),
            type: "date",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            placeholder: "模板失效日期"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "备注",
        prop: "remark"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            "show-word-limit": "",
            maxlength: "150",
            modelValue: formSchema.value.remark,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.remark) = $event)),
            rows: "4",
            placeholder: "备注"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "是否启用",
        prop: "is_enabled"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_group, {
            modelValue: formSchema.value.is_enabled,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.is_enabled) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_button, { label: "Y" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio_button, { label: "N" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "模板文件" }, {
        default: _withCtx(() => [
          _createVNode(_unref(UploadFile), {
            "category-id": "a3bb657c-7760-6528-3d91-9dc70fba5501",
            "type-id": "7414ebf5-a4ec-e9c5-5102-2b4878952d76",
            "relation-id": formSchema.value.id || '',
            "type-desc": "模板文件",
            onOnSuccess: onUploadSuccess
          }, null, 8, ["relation-id"]),
          _createElementVNode("span", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(formSchema.value.material?.file_name || '未上传'), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"])), [
    [_directive_loading, _unref(state).loading]
  ])
}
}

})